<template>
    <div>
        <CRow>
            <CCol sm="2">
                <div class="form-group">
                    <label>از تاریخ</label>
                    <date-picker v-model="fromDate"
                                 input-format="YYYY-MM-DD HH:mm:ss"
                                 locale="fa" format="YYYY-MM-DD"
                                 display-format="jYYYY-jMM-jDD">
                    </date-picker>
                </div>
            </CCol>
            <CCol sm="2">
                <div class="form-group">
                    <label>تا تاریخ</label>
                    <date-picker v-model="toDate"
                                 input-format="YYYY-MM-DD HH:mm:ss"
                                 locale="fa" format="YYYY-MM-DD"
                                 display-format="jYYYY-jMM-jDD">
                    </date-picker>
                </div>
            </CCol>
            <CCol sm="2">
                <div class="form-group">
                    <CButton color="info" class="mb-2 ml-2 text-white mt-7"
                             @click="getResult">
                        اعمال
                    </CButton>
                </div>
            </CCol>
        </CRow>
        <CAlert :color="notify.color" v-for="notify in dashboardData.notifications" v-bind:key="notify.id" v-bind:value="notify.id">
          {{ notify.text }}
        </CAlert>
        <WidgetsDropdown :data="dashboardData" v-if="dashboardData.accounts.length > 0"/>
        <CRow v-if="dashboardData.accounts.length > 0">
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        حساب ها
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                                class="mb-0 table-outline"
                                hover
                                :items="dashboardData.accounts"
                                :fields="tableFields"
                                head-color="light"
                                no-sorting>
                            <td slot="balance" slot-scope="{item}">
                                <div>{{item.balance | currency('', 0, { symbolOnLeft: false })}} ریال</div>
                            </td>
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CCard v-if="dashboardData.accounts.length > 0">
            <CCardBody>
                <CRow>
                    <CCol sm="5">
                        <h4 class="card-title mb-0">درامدها و پرداختی ها</h4>
                    </CCol>
                </CRow>
                <MainChartExample style="height:300px;margin-top:40px;" :info-data="dashboardData.pricing"/>
            </CCardBody>
        </CCard>
        <CCard v-if="dashboardData.accounts.length > 0">
            <CCardBody>
                <CRow>
                    <CCol sm="5">
                        <h4 class="card-title mb-0">فاکتورهای خرید و فروش</h4>
                    </CCol>
                </CRow>
                <MainChartExample style="height:300px;margin-top:40px;" :info-data="dashboardData.invoices"/>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
    import MainChartExample from './charts/MainChartExample'
    import WidgetsDropdown from './widgets/WidgetsDropdown'
    import {getDashboard} from '../webservice/webservice'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

    export default {
        name: 'Dashboard',
        components: {
            MainChartExample,
            WidgetsDropdown,
            datePicker: VuePersianDatetimePicker
        },
        data() {
            return {
                dashboardData: {},
                tableFields: [
                    {key: 'name', label: 'نام حساب'},
                    {key: 'balance', label: 'موجودی'}
                ],
                fromDate: this.formatDate((new Date())),
                toDate: this.formatDate(new Date())
            }
        },
        mounted() {
            let d = new Date();
            d.setMonth(d.getMonth() - 1);
            this.fromDate = this.formatDate(d);
            getDashboard(this.$http, this.fromDate, this.toDate).then((resp) => {
                this.dashboardData = resp
            })
        },
        methods: {
            getResult() {
                getDashboard(this.$http, this.fromDate, this.toDate).then((resp) => {
                    this.dashboardData = resp
                })
            },
            color(value) {
                let $color;
                if (value <= 25) {
                    $color = 'info'
                } else if (value > 25 && value <= 50) {
                    $color = 'success'
                } else if (value > 50 && value <= 75) {
                    $color = 'warning'
                } else if (value > 75 && value <= 100) {
                    $color = 'danger'
                }
                return $color
            },
            formatDate(date) {
                let d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [year, month, day].join('-');
            }
        }
    }
</script>
